<template>
  <div class="household-icons" :class="{ 'is-over-two': quantity > 2, 'is-over-eight': quantity > 8 }">
    <svg v-for="(icon, index) in qty" :key="`icon-${index}`" class="household-icons__icon" viewBox="0 0 16 16">
      <use xlink:href="#user" />
    </svg>
    <template v-if="displayPlus">
      <svg class="household-icons__icon is-plus" viewBox="0 0 16 16">
        <use xlink:href="#plus" />
      </svg>
    </template>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  quantity: {
    type: Number,
    default: 1,
  },
});

const max = 10;

const qty = computed(() => {
  if (props.quantity > max) {
    return max - 1;
  }
  return props.quantity;
});

const displayPlus = computed(() => {
  if (props.quantity > qty.value) {
    return true;
  }
  return false;
});
</script>

<style lang="scss" scoped>
.household-icons {
  display: inline-grid;
  grid-auto-flow: column;
  grid-auto-columns: min-content;
  justify-content: center;
  align-content: center;

  &.is-over-two {
    grid-template-rows: repeat(2, min-content);
    grid-template-columns: unset;
  }

  &.is-over-eight {
    svg:nth-child(1),
    svg:nth-child(2) {
      @include tiny {
        display: none;
      }
    }
  }

  &__icon {
    width: rem(30);

    .is-over-two & {
      width: rem(17);
    }

    .is-over-eight & {
      @include tiny {
        width: rem(15);
      }
    }
  }
}
</style>
